import { render, staticRenderFns } from "./add_addresss.vue?vue&type=template&id=b28e38f0&scoped=true"
import script from "./add_addresss.vue?vue&type=script&lang=js"
export * from "./add_addresss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28e38f0",
  null
  
)

export default component.exports